<template>
	<div id="app">
		<router-view class="app" v-if="isRouterAlive"></router-view>


    <!-- 无适配弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :show-close="false"
      class="no-adaptation"
      custom-class="no-adaptation w-820"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="content">
        <img class="w-240 h-240" src="@/assets/img/common/wushipei.svg" alt="">
        <h2>温馨提示</h2>
        <p>此页面建议前往电脑端查看</p>
        <el-button class="min-w-200" type="primary" @click="dialogVisible = false">确认</el-button>
      </div>
    </el-dialog>
	</div>
</template>
<script>
export default {
	name: 'App',
	provide () {
		return {
			reload: this.reload
		}
	},
	data () {
		return {
			isRouterAlive: true,
      dialogVisible: false
		}
	},
	created () {
		document.documentElement.setAttribute('style', `--vh:${window.innerHeight * 0.01}px`)
		console.log('apiConfig env: ', window.env, ', current env: ', process.env.NODE_ENV)
		this.setAPPLanguage(localStorage.getItem('art-i18n_language') || 'zh-cn')
    setTimeout(() => {
      this.$utils.setRem()
      this.showNoAdaptation()
    }, 500)
  },
	watch: {
	  '$route.path' () {
      this.$utils.setRem()
      this.showNoAdaptation()
    }
	},
	mounted() {
    if (window.env !== 'development') {
      // 为右键添加自定义事件，可以禁用
      window.oncontextmenu = function(event) {
        event.preventDefault(); // 阻止默认事件行为
        return false;
      }
      window.onkeydown = window.onkeyup = window.onkeypress = function (event) {
        // 判断是否按下F12，F12键码为123
        if (event.keyCode == 123) {
          event.preventDefault(); // 阻止默认事件行为
          window.event.returnValue = false;
          return false;
        }else if ((event.ctrlKey) && (event.keyCode == 83 || event.keyCode === 85)) {
          //ctrl+s
          return false;
        }else if(window.event.ctrlKey && window.event.shiftKey && window.event.keyCode == 73) {
          //禁用ctrl+shift+i,
          return false;
        }
      }
    }
  },
	methods: {
		reload () {
			this.isRouterAlive = false
			this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},
		setAPPLanguage (language) {
			this.loadLanguageAsync(language).then((res) => {
				if (typeof res === 'object') {
					this.setAPPLanguage('zh-cn')
				} else {
					this.$store.commit('global/SET_LANG_I18n', language)
					localStorage.setItem('art-i18n_language', language)
				}
			})
		},
    /**
    * 显示无适配弹窗
    * */
    showNoAdaptation () {
      // this.dialogVisible = !this.$utils.compatibleMobilePage.includes(this.$route.name) && document.body.clientWidth <= 991
      this.dialogVisible = false
    }
	}
}
</script>

<style lang="less">
  @import url('theme/element/display.css');
  @import url('theme/element/index.css');
  @import url('theme/element/index_copy.css');
  @import url('./assets/css/style.less');
  .no-adaptation{
    border-radius: 16px;
    .el-dialog__header{
      display: none;
    }
    .el-dialog__body{
      padding: 28px 40px 70px;
    }
    .content{
      text-align: center;
      h2{
        font-size: 48px;
        font-family: HarmonyOS_Sans_SC;
        color: #232323;
        line-height: 64px;
      }
      p{
        margin: 32px 0 72px;
        font-size: 32px;
        font-family: HarmonyOS_Sans_SC;
        color: #9C9C9C;
        line-height: 40px;
      }
      .el-button{
        border: 2px solid #232323;
        padding: 24px 40px;
        font-size: 28px;
        border-radius: 8px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue